module.exports = __webpack_public_path__ + "img/icon_li.357d21c8.svg";